import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { IBalooSyncLog } from '../../baloo';
import { ObjectTypes } from '@fi-shared/types';
import { AppTextService } from '@fi-shared/app-text';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-baloo-sync-log-details-dialog',
    template: `
        <fi-baloo-sync-log-details
            [syncLog]="this.data"
            [isTestSync]="false"
            [isSyncLogDateSectionShown]="false"
            [syncLogHeading]="getSyncLogHeading()"
        >
            <button
                sync-log-action-button
                mat-button
                class="BrandedBackgroundColor exclude-from-print-html"
                (click)="closeDialog()"
            >
                {{ 'common.close' | fiAppText }}
            </button>
        </fi-baloo-sync-log-details>
    `,
    styleUrls: ['./baloo-sync-log-details-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-baloo-sync-log-details-dialog' },
    standalone: false,
})
export class BalooSyncLogDetailsDialogComponent extends FiDialogsContentBase<IBalooSyncLog, void> implements OnInit {
    ngOnInit(): void {
        this.initServices();
    }

    getSyncLogHeading(): string {
        return `${this.getSyncLogLabel()} ${this.fiFormatDateService.formatDate(this.data.CreatedOn, 'date-time', { showToday: false })}`;
    }

    closeDialog() {
        this.dialogRef.close();
    }

    private getSyncLogLabel() {
        switch (this.data.ObjectType) {
            case ObjectTypes.BusinessUnit:
                return this.appTextService.get('baloo.unit_sync_log');
            case ObjectTypes.Role:
                return this.appTextService.get('baloo.role_sync_log');
            case ObjectTypes.User:
                return this.appTextService.get('baloo.user_sync_log');
        }
    }

    private appTextService: AppTextService;
    private fiFormatDateService: FiFormatDateService;
    private initServices() {
        this.appTextService = this.injector.get(AppTextService);
        this.fiFormatDateService = this.injector.get(FiFormatDateService);
    }
}
